import { createSlice, nanoid } from '@reduxjs/toolkit';
import { MAX_NUM } from '../../components/Ratings';
import { RootState } from 'js/store';

export type Student = {
    id: string;
    name: string;
    classId: string;
}

export const initialState: Array<Student> = [];

export const studentSlice = createSlice({
    name: 'students',
    initialState,
    reducers: {
        addStudent: (state, { payload }) => {
            const { classId } = payload;
            const id = nanoid();
            const name = '';
            state.push({ id, name, classId });
        },
        editStudent: (state, { payload }) => {
            const { id, name } = payload;
            const student = state.find(student => student.id === id) || {} as Student;
            student.name = name;
        },
        deleteStudents: (state, { payload }) => {
            // TODO: also delete all student's ratings
            const { studentIds = [] } = payload;
            studentIds.forEach(studentId => {
                const studentIndex = state.findIndex((student) => student.id === studentId);
                (studentIndex > -1) && state.splice(studentIndex, 1);
            })
        },
    },
});

// Action creators are generated for each case reducer function
export const { addStudent, editStudent, deleteStudents } = studentSlice.actions;

// Selectors
export const selectStudents = state => state.students;

export const getStudentsByClassId = (state, classId) => {
    const students = selectStudents(state);
    return students.filter(student => student.classId === classId);
};

export const getStudentIdsByClassId = (state, classId) => {
    const students = getStudentsByClassId(state, classId);
    return students.map(({ id }) => id);
};

export const getMaxClassScore = (state) => {
    const students = selectStudents(state);
    return students.length * MAX_NUM;
};

export const getStudentIds = (state) => {
    const students = selectStudents(state);
    return students.map(student => student.id);
};

export const getStudentById = (state: RootState, studentId:string) => {
    const students = selectStudents(state);
    return students.find(student => student.id === studentId) || <Student>{};
}

export default studentSlice.reducer;